import {
  GetDocumentSettingsResponseDto,
  InformationForContentDeclarationResponseDto,
  InformationForDocumentResponseDto,
} from '@tiendanube/common';
import { DocumentType } from 'domains/FulfillmentOrders/pages/PrintDocumentPage/constants';
import DocumentPreview from '../DocumentPreview';

interface BoxShippingDocumentPreviewProps {
  information?:
    | InformationForContentDeclarationResponseDto[]
    | InformationForDocumentResponseDto[];
  isLoading: boolean;
  settings: GetDocumentSettingsResponseDto;
  locationId: string;
}

function BoxShippingDocumentPreview({
  information,
  isLoading,
  settings,
  locationId,
}: Readonly<BoxShippingDocumentPreviewProps>) {
  const columnsPerPage = settings.showHorizontalDocumentsPerPage || 2;
  const hasEnhancedLayout =
    settings.showCheckboxPicking || settings.showProductImage;

  const twoColumnsStyle = {
    display: 'grid' as const,
    gridTemplateColumns: information?.length === 1 ? '1fr' : '1fr 1fr',
    columnGap: '0',
    width: information?.length === 1 ? '50%' : '100%',
    alignItems: isLoading ? ('center' as const) : ('flex-start' as const),
    justifyContent: 'center' as const,
    paddingLeft: '2%',
  };

  const oneColumnStyle = {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    padding: '2%',
    width: '100%',
  };

  const shouldUseSimpleLayout = information?.length && information.length <= 2;

  let containerStyle;
  if (shouldUseSimpleLayout) {
    containerStyle = columnsPerPage === 2 ? twoColumnsStyle : oneColumnStyle;
  } else {
    containerStyle = {
      width: '100%',
      justifyContent: 'center',
      alignItems: isLoading ? 'center' : 'flex-start',
      columns: columnsPerPage,
      columnGap: '0',
      padding: '2%',
    };
  }

  return (
    <div
      id={`print-container-${
        columnsPerPage === 1 ? DocumentType.RECEIPT : DocumentType.LABEL
      }`}
      className={hasEnhancedLayout ? 'enhanced-shipping-document' : ''}
      style={containerStyle}
    >
      {!isLoading && information && (
        <DocumentPreview
          type={DocumentType.SHIPPING_DOCUMENT}
          information={information as InformationForDocumentResponseDto[]}
          settings={settings}
          locationId={locationId}
        />
      )}
    </div>
  );
}

export default BoxShippingDocumentPreview;
